import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import Style from '../assets/css/email.module.css';

function Mail() {
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [phone, setPhone] = useState('');
    const { t } = useTranslation();

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Inicializa EmailJS con tu clave pública
        emailjs.init('uzThu-LtxMRlSeoj4');

        // Crea un objeto con los datos del formulario
        const formData = {
            email,
            subject,
            message: body,
            phone,
        };

        // Envía el formulario a través de EmailJS
        emailjs.send("service_mkeblg3", "template_5powu8b", {
            name: formData.email,
            subject: formData.subject,
            message: formData.message,
            phone: formData.phone,
        })
        .then((response) => {
            Swal.fire(
                'Email sent!',
                'Your email was sent successfully!',
                'success'
            );

            setEmail('');
            setSubject('');
            setBody('');
            setPhone('');
        }, (error) => {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong, email could not be sent!'
            });
        });
    };

    return (
        <section className={Style.mailContainer}>
            <div className={Style.titleMailContainer}>
                <h1 className={Style.titleMail}>{t('titleMail')}</h1>
            </div>
            <form onSubmit={handleSubmit} className={Style.mailForm}>
                <div className={Style.formGroup}>
                    <label className={Style.labelMail} htmlFor="email">{t('mail')}</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder={t('mailType')}
                        autoComplete='off'
                        className={Style.inputMail}
                    />
                </div>
                <div className={Style.formGroup}>
                    <label className={Style.labelMail} htmlFor="subject">{t('subject')}</label>
                    <input
                        id="subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                        placeholder={t('subjectType')}
                        className={Style.inputMail}
                    />
                </div>
                <div className={Style.formGroup}>
                    <label className={Style.labelMail} htmlFor="phone">{t('phoneNumber')}</label>
                    <input
                        type="tel"
                        id="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                        placeholder={t('phoneType')}
                        className={Style.inputMail}
                    />
                </div>
                <div className={Style.formGroup}>
                    <label className={Style.labelMail} htmlFor="body">{t('body')}</label>
                    <textarea
                        type="text"
                        id="body"
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        required
                        placeholder={t('bodyType')}
                        className={Style.textareaMail}
                    />
                </div>
                <button className={Style.buttonMail} type="submit">{t('sendEmail')}</button>
            </form>
        </section>

    );
}

export default Mail;
